type ClassValue = string | false | null | undefined;

/**
 * Minimal class name joiner. Components compose classes from variant maps
 * rather than merging conflicting utilities, so no `tailwind-merge` is needed.
 */
export function cn(...values: ClassValue[]): string {
  return values.filter((value): value is string => Boolean(value)).join(' ');
}
